import base from '../dr-base'
import drExpansionPanel from './dr-expansion-panel.vue'

const schema = {
  $Type: 'dr-expansion-panel',
  name: 'Expansion panel',
  group: 'Container widgets',
  icon: 'window-maximize',
  ...base,
  properties: {
    ...base.properties,
    PanelItems: {
      type: 'array',
      items: {
        type: 'object'
      },
      default: [
        {
          $ID: '0.12088803405041415',
          $Type: 'dr-expansion-panel-item',
          Text: 'Panel Item',
          Widgets: []
        },
        {
          $ID: '0.10700096029126738',
          $Type: 'dr-expansion-panel-item',
          Text: 'Panel Item1',
          Widgets: []
        },
        {
          $ID: '0.7840955020739653',
          $Type: 'dr-expansion-panel-item',
          Text: 'Panel Item2',
          Widgets: []
        }
      ]
    },
    Widgets: {
      type: 'array'
    },
    CurrentPanel: {
      name: 'vuetifyWidgets.dr-expansion-panel.currentPanel',
      type: 'string',
      hint: 'vuetifyWidgets.dr-expansion-panel.hint'
    },
    Multiple: {
      name: 'vuetifyWidgets.dr-expansion-panel.multiple',
      type: 'boolean',
      default: false
    },
    ClassPanels: {
      name: 'vuetifyWidgets.dr-expansion-panel.classPanels',
      type: 'string',
      default: ''
    }
  }
}

export default {
  schema,
  component: drExpansionPanel
}
